/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Link } from '@coursera/event-pulse/react';

import TrackedDiv from 'bundles/page/components/TrackedDiv';
import {
  CONTENT_COUNT_BUTTON_TRACKING_NAME,
  CONTENT_COUNT_SECTION_NAME,
  CONTENT_COUNT_TRACKING_NAME,
} from 'bundles/unified-description-page-common/components/modules/key-information/KeyInformationContentCount';
import KeyInformationDetailsItem from 'bundles/unified-description-page-common/components/modules/key-information/KeyInformationDetailsItem';
import { useEventingProductData } from 'bundles/unified-description-page-common/contexts/EventingContext';
import { PROJECT_NAV_ITEMS } from 'bundles/unified-description-page-common/utils/getPageNavigationLinks';

type Props = {
  title: string;
  subtitle: string;
};

const styles = {
  link: css`
    /* override cds link color */
    color: var(--cds-color-neutral-primary) !important;
  `,
  detailItemWrapper: css`
    display: inline-flex;
  `,
};

export const KeyInformationProjectProductType = ({ title, subtitle }: Props) => {
  const eventingProductData = useEventingProductData();

  /**
   * ProductType originally piggy backed off of the ModuleCount component,
   * for this reason we use the same tracking information for historical reasons.
   *
   * This is not sacred but its usage isn't clear.
   */
  return (
    <KeyInformationDetailsItem
      title={
        <TrackedDiv trackingName={CONTENT_COUNT_TRACKING_NAME}>
          <Link
            href={`#${PROJECT_NAV_ITEMS.DETAILS}`}
            trackingData={{
              button: { name: CONTENT_COUNT_BUTTON_TRACKING_NAME },
              pageSection: {
                sectionName: CONTENT_COUNT_SECTION_NAME,
              },
              ...eventingProductData,
            }}
            noViewTracking
            css={styles.link}
          >
            {title}
          </Link>
        </TrackedDiv>
      }
      subtitle={subtitle}
    />
  );
};

export default KeyInformationProjectProductType;
